import script from "./LocationBlockToGarage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocationBlockToGarage.vue?vue&type=script&setup=true&lang=ts"

import "./LocationBlockToGarage.vue?vue&type=style&index=0&id=7eef5e96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eef5e96"]])

export default __exports__